"use client";

import { track } from "@/lib/metrika";

// Триггер модалки «Обратная связь» — кнопка, стилизованная под ссылку.
// Кликом шлёт событие 'open-feedback', которое ловит единая FeedbackModal.
export default function FeedbackLink({
  className, style, children, onClick,
}: {
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
  onClick?: () => void;
}) {
  return (
    <button
      type="button"
      className={className}
      style={{ background: "none", border: "none", padding: 0, cursor: "pointer", font: "inherit", textAlign: "left", ...style }}
      onClick={() => { track("feedback_open"); onClick?.(); window.dispatchEvent(new Event("open-feedback")); }}
    >
      {children}
    </button>
  );
}
